import { Dimensions } from "react-native";

export const widthMargin = 20;
export default () => Dimensions.get("window").width;
